import React from "react";
import { relative } from "path";

class MenuItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }
  render() {
    const { name, selected, route, navigate: nav, icon, iconFile, id } = this.props;

    const navigate = (...args) => {
      googleAnalyticsNavigationLog(name);
      nav(...args);
    }

    return (
      <>
        {name === "¿Necesitas ayuda?" ? (
          <div
            className={`menu-item ${
              selected || this.state.hover ? "active" : ""
            }`}
            onClickCapture={() =>
              window.cnsWidgetPlugin.command('WebChat.open')
            }
            onMouseEnter={() => this.setState({ hover: true })}
            id={id}
            onMouseLeave={() => this.setState({ hover: false })}
          >
            {iconFile ? (
              <i
                className={`menu-icon ${selected ? "selected" : ""}`}
                style={{
                  marginTop: -4,
                  paddingRight: 14,
                  marginLeft: 5,
                  fontSize: 18,
                }}
              >
                <img src={iconFile} alt="" />
              </i>
            ) : name === "Denuncias" || name === "Prestaciones económicas" ? (
              <i
                className={`achs-family-icon menu-icon ${
                  selected ? "selected" : ""
                }`}
                style={{
                  marginTop: -4,
                  paddingRight: 10,
                  fontSize: 34,
                  position: relative,
                  right: 8,
                }}
              >
                {icon || "B"}
              </i>
            ) : name === "Plan de Movilidad" ? (
              <i
                className={`achs-family-icon menu-icon ${
                  selected ? "selected" : ""
                }`}
                style={{
                  marginTop: -4,
                  paddingRight: 10,
                  fontSize: 34,
                  marginLeft: -5,
                }}
              >
                {icon || "B"}
              </i>
            ) : name === "COVID-19" ||
              //name === "Capacitaciones" ||
              name === "Capacitaciones E-learning" ||
              "Lesiones graves y fatales" ||
              "Autoevaluación Legal" ? (
              <i
                className={`achs-family-icon menu-icon ${
                  selected ? "selected" : ""
                }`}
                style={{ marginTop: -4, paddingRight: 14, fontSize: 34 }}
              >
                {icon || "B"}
              </i>
            ) : (
              <i
                className={`achs-icon menu-icon ${selected ? "selected" : ""}`}
                style={{ marginTop: -4, paddingRight: 10, fontSize: 34 }}
              >
                {icon || "B"}
              </i>
            )}
            <span className={`menu-item-text ${selected ? "selected" : ""}`}>
              {name}
            </span>
          </div>
        ) : (
          <div
            className={`menu-item ${
              selected || this.state.hover ? "active" : ""
            }`}
            onClickCapture={() => !selected && navigate(route)}
            onMouseEnter={() => this.setState({ hover: true })}
            id={id}
            onMouseLeave={() => this.setState({ hover: false })}
          >
            {iconFile ? (
              <i
                className={`menu-icon ${selected ? "selected" : ""}`}
                style={{
                  marginTop: -4,
                  paddingRight: 14,
                  marginLeft: 5,
                  fontSize: 18,
                }}
              >
                <img src={iconFile} alt="" />
              </i>
            ) : name === "Denuncias" || name === "Prestaciones económicas" ? (
              <i
                className={`achs-family-icon menu-icon ${
                  selected ? "selected" : ""
                }`}
                style={{
                  marginTop: -4,
                  paddingRight: 10,
                  fontSize: 34,
                  position: relative,
                  right: 8,
                }}
              >
                {icon || "B"}
              </i>
            ) : name === "Plan de Movilidad" ? (
              <i
                className={`achs-family-icon menu-icon ${
                  selected ? "selected" : ""
                }`}
                style={{
                  marginTop: -4,
                  paddingRight: 10,
                  fontSize: 34,
                  marginLeft: -5,
                }}
              >
                {icon || "B"}
              </i>
            ) : name === "COVID-19" ||
              name === "Capacitaciones" ||
              "Lesiones graves y fatales" ? (
              <i
                className={`achs-family-icon menu-icon ${
                  selected ? "selected" : ""
                }`}
                style={{ marginTop: -4, paddingRight: 14, fontSize: 34 }}
              >
                {icon || "B"}
              </i>
            ) : (
              <i
                className={`achs-icon menu-icon ${selected ? "selected" : ""}`}
                style={{ marginTop: -4, paddingRight: 10, fontSize: 34 }}
              >
                {icon || "B"}
              </i>
            )}
            <span className={`menu-item-text ${selected ? "selected" : ""}`}>
              {name}
            </span>
          </div>
        )}
      </>
    );
  }
}

function googleAnalyticsNavigationLog(name) {
  let event = { event: 'click_menu', accion: 'click' };

  switch(name.toLowerCase()) {
    case 'mis siniestros':
      event.menu = 'trabajador_siniestros';
      event.contenido = 'menu_siniestros';
      break;

    case 'capacitaciones e-learning':
      event.menu = 'trabajador_capacitaciones';
      event.contenido = 'menu_capacitaciones';
      break;

    case 'resultados exámenes de salud':
      event.menu = 'trabajador_resultados_examenes';
      event.contenido = 'menu_resultados_examenes';
      break;

    case 'pagos pendientes':
      event.menu = 'trabajador_pagos_pendientes';
      event.contenido = 'menu_pagos_pendientes';
      break;

    case 'estado pensión e indemnización':
      event.menu = 'trabajador_estado_pension';
      event.contenido = 'menu_estado_pension';
      break;

    case 'mundo achs':
      event.menu = 'MUNDO_ACHS_TRAB_SMENU';
      event.contenido = 'MUNDO_ACHS_TRAB_SMEN';
      break;


    case 'datos empresa':
      break;

    case 'gestionar usuarios':
      break;

    case 'siniestros':
      break;

    case 'plan de movilidad':
      break;

    case 'agendamiento experto':
      break;

    case 'achs gestión':
      event.menu = 'empresas_achs_gestion';
      event.contenido = 'menu_achs_gestion';
      break;

    case 'denuncias':
      event.menu = 'empresas_denuncias';
      event.contenido = 'menu_denuncias';
      break;

    case 'prestaciones económicas':
      event.menu = 'empresas_prestaciones_economica';
      event.contenido = 'menu_prestaciones_economicas';
      break;

    case 'certificados':
      break;

    case 'devoluciones':
      event.menu = 'empresas_devoluciones';
      event.contenido = 'menu_devoluciones';
      break;

    case 'prevención':
      event.menu = 'empresas_prevencion';
      event.contenido = 'menu_prevencion';
      break;

    case 'lesiones graves y fatales':
      event.menu = 'empresas_lgf';
      event.contenido = 'menu_lgf';
      break;

    case 'estadísticas':
      event.menu = 'empresas_estadisticas';
      event.contenido = 'menu_estadisticas';
      break;

    case 'decreto supremo n°67':
      event.menu = 'empresas_decreto_supremo_67';
      event.contenido = 'menu_decreto_supremo_67';
      break;

    case 'tour guiado':
      event.menu = 'soporte_tour_guiado';
      event.contenido = 'menu_tour_guiado';
      break;

    case 'material soporte':
      event.menu = 'soporte_material';
      event.contenido = 'menu_material';
      break;

    case 'te ayudamos':
      event.menu = 'soporte_teayudamos';
      event.contenido = 'menu_teayudamos';
      break;

    case 'mi perfil':
      event.menu = 'micuenta';
      event.contenido = 'menu_miperfil';
      break;

    case 'solicitudes':
      event.menu = 'micuenta';
      event.contenido = 'menu_solicitudes';
      break;

    case 'empresas achs':
      break;

    case 'contact center':
      break;

    case 'general':
      break;

    case 'sel':
      break;

    case 'trabajadores achs':
      break;

    default:
      break;
  }

  if(event.menu)
  {
    window.dataLayer.push(event);
  }
}

export default MenuItem;
